import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('heatmap-chart', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('heatmap-chart');

      return new ViewModel(params, element);
    },
  },
  template: html,
}); 